var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterX = function SvgTwitterX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 30,
    fill: "none",
    className: "social-link"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.3023.003h4.9641L20.4242 12.392l12.7547 16.8609h-9.9844l-7.8258-10.2234-8.9438 10.2234H1.454L13.0484 15.999.821.003h10.2375l7.0665 9.3445L26.3023.0029Zm-1.7438 26.2827h2.7493L9.5608 2.8154h-2.953l17.9507 23.4703Z"
  })));
};
export default SvgTwitterX;